import { render } from "./MessageComponent.vue?vue&type=template&id=4048b739&scoped=true"
import script from "./MessageComponent.vue?vue&type=script&lang=ts"
export * from "./MessageComponent.vue?vue&type=script&lang=ts"

import "./MessageComponent.vue?vue&type=style&index=0&id=4048b739&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4048b739"

export default script